import classNames from 'clsx';
import React, { FC } from 'react';

import styles from './WebSearchSource.css';

interface SearchSourceProps {
    query: string;
    className?: string;
}

export const WebSearchSource: FC<SearchSourceProps> = ({ className, query }) => (
    <div className={classNames(styles.source, className)}>
        Содержит ...<mark className={styles.match}>{query}</mark>...
    </div>
);

WebSearchSource.displayName = 'WebSearchSource';
